import React from "react";
import {
  StickerStar, StickerBolt, StickerSun, StickerSurf, StickerWave, StickerShoe,
} from "../components/Stickers";

/* ===========================================================
   MEDIA PAGE
   Edit titles, descriptions, or URLs inline (Visual Edit Mode).
   URL placeholders point at each outlet's main domain so they
   open something real. Swap for the exact article URL once you
   have them handy.
   =========================================================== */

const TOP_FEATURES = [
  {
    rank: 1,
    title: "Canadian Running Magazine",
    outlet: "Canadian Running Magazine",
    type: "Article",
    desc: "Core feature celebrating the completion of the 160-day, 7,000 km journey across Canada for cancer research.",
    url: "https://runningmagazine.ca/the-scene/winnipeg-man-completes-cross-canada-run-for-cancer-research/",
    color: "#F87171",
  },
  {
    rank: 2,
    title: "CTV News Vancouver",
    outlet: "CTV News Vancouver",
    type: "Video",
    desc: "The big finish. Major coverage of the final arrival in Port Coquitlam at the Terry Fox Hometown Plaza, hitting the $100,000 milestone.",
    url: "https://www.ctvnews.ca/vancouver/article/man-inspired-by-terry-fox-finishes-cross-canada-run-in-port-coquitlam/",
    color: "#F4A261",
  },
];

const NATIONAL = [
  {
    title: "Global News",
    outlet: "Global News",
    type: "Article",
    desc: "Highlighting the digital side of the run, livestreaming the journey across Canada and building an online community to fundraise.",
    url: "https://globalnews.ca/news/9624762/manitoba-man-livestreams-walk-across-canada-fundraise-cancer-research/",
  },
  {
    title: "Global News (Video Broadcast)",
    outlet: "Global News",
    type: "Video",
    desc: "Video news segment tracking the live walk and community interaction.",
    url: "https://globalnews.ca/video/9625724/manitoba-man-livestreams-walk-across-canada-to-raise-money-for-cancer-research",
  },
  {
    title: "CHVN 95.1 FM",
    outlet: "CHVN 95.1 FM",
    type: "Article",
    desc: "Local Winnipeg coverage following the hometown inspiration and steps in honour of Terry Fox.",
    url: "https://www.chvnradio.com/articles/winnipeg-man-following-in-terry-foxs-steps-and-travels-across-canada",
  },
];

const REGIONAL_CTV = [
  {
    title: "CTV News Atlantic",
    outlet: "CTV News Atlantic",
    type: "Article",
    desc: "The early stages of the journey pushing through eastern Canada.",
    url: "https://www.ctvnews.ca/atlantic/article/winnipeg-man-running-across-canada-in-support-of-cancer-research/",
  },
  {
    title: "CTV News Ottawa",
    outlet: "CTV News Ottawa",
    type: "Article",
    desc: "Mid-journey tracking as the run made its way through the nation's capital.",
    url: "https://www.ctvnews.ca/ottawa/article/man-running-across-canada-for-cancer-research-passes-through-ottawa/",
  },
  {
    title: "CTV News Winnipeg (Poseidon)",
    outlet: "CTV News Winnipeg",
    type: "Article",
    desc: "In-depth breakdown and discussion of the roots, inspiration, and grueling trek.",
    url: "https://www.ctvnews.ca/winnipeg/article/winnipeg-man-discusses-his-cross-canada-run-inspired-by-terry-fox/",
  },
  {
    title: "CTV News Calgary",
    outlet: "CTV News Calgary",
    type: "Article",
    desc: "Deep into the run, documenting the grind, shoe wear-and-tear, and matching Terry's path through Alberta.",
    url: "https://www.ctvnews.ca/calgary/article/inspired-by-terry-fox-winnipeg-man-is-running-walking-across-canada-to-raise-money-for-cancer-research/",
  },
];

const LOCAL_PRESS = [
  {
    title: "Pembroke Today",
    outlet: "Pembroke Today",
    type: "Article",
    desc: "Highlighting the goal to join elite athletic company with the 2023 cross-Canada run.",
    url: "https://www.pembroketoday.ca/2023/05/08/manitoba-man-hopes-to-join-elite-company-with-2023-cross-canada-marathon/",
  },
  {
    title: "BayToday (North Bay)",
    outlet: "BayToday",
    type: "Article",
    desc: "Spotlighting the relentless push from coast to coast while passing through northern Ontario.",
    url: "https://www.baytoday.ca/local-news/winnipeg-man-walking-coast-to-coast-for-cancer-7003543",
  },
  {
    title: "Moose Jaw Today",
    outlet: "Moose Jaw Today",
    type: "Article",
    desc: "Anticipation of the arrival in Moose Jaw on the hard push across the Prairies.",
    url: "https://www.moosejawtoday.com/local-news/25-year-old-marathoning-across-canada-in-honour-of-terry-fox-soon-reaching-moose-jaw-7216149",
  },
  {
    title: "Discover Moose Jaw (#1)",
    outlet: "Discover Moose Jaw",
    type: "Article",
    desc: "The shared determination and hope spreading down the highways.",
    url: "https://www.discovermoosejaw.com/articles/two-determined-men-trek-across-canada-spreading-hope-and-raising-funds-in-search-of-a-cancer-cure",
  },
  {
    title: "Discover Moose Jaw (#2)",
    outlet: "Discover Moose Jaw",
    type: "Article",
    desc: "Coverage of the official pit stop in town during the Prairie stretch.",
    url: "https://www.discovermoosejaw.com/articles/cross-canada-jax-makes-a-pit-stop-in-moose-jaw-",
  },
  {
    title: "Vancouver Is Awesome (Port Coquitlam Arrival)",
    outlet: "Vancouver Is Awesome / Tri-City News",
    type: "Article",
    desc: "Hype building up to the final finish line celebration in Port Coquitlam.",
    url: "https://www.vancouverisawesome.com/tri-city-news-archive/news/runner-to-complete-cross-country-journey-in-port-coquitlam-to-honour-his-hero-terry-fox-7397831",
  },
];

const BOOK_TOUR = [
  {
    title: "Chat News Today (Medicine Hat)",
    outlet: "Chat News Today",
    type: "Article",
    desc: "Sharing the cross-Canada journey with Hatters on the summer tour to keep supporting cancer research.",
    url: "https://chatnewstoday.ca/2024/06/03/runner-shares-cross-canada-journey-with-hatters-to-support-cancer-research/",
  },
  {
    title: "The North Bay Nugget",
    outlet: "The North Bay Nugget",
    type: "Article",
    desc: "Recapping the $100K milestone during the tour stop back through North Bay.",
    url: "https://www.nugget.ca/news/man-who-raised-100000-in-canada-wide-cancer-journey-stops-in-north-bay",
  },
  {
    title: "Vancouver Is Awesome / Tri-City News (PoCo Return)",
    outlet: "Vancouver Is Awesome / Tri-City News",
    type: "Article",
    desc: "Capturing the return to Port Coquitlam, transitioning from cross-country runner to published children's author.",
    url: "https://www.vancouverisawesome.com/tri-city-news-archive/news/runner-who-replicated-terry-foxs-cross-country-trek-back-in-port-coquitlam-today-as-an-author-9023701",
  },
];

const TypePill = ({ type }) => (
  <span className={`font-pixel uppercase tracking-widest text-sm px-2 py-1 border-2 border-black ${type === "Video" ? "bg-[#F87171] text-white" : "bg-[#F4D58D] text-black"}`}>
    {type}
  </span>
);

const SectionHeader = ({ title, color }) => (
  <div className="mb-8 mt-16">
    <h2 className="font-display tracking-wider text-3xl sm:text-4xl text-black leading-none flex items-center gap-3"
        style={{ textShadow: "3px 3px 0 rgba(0,0,0,0.15)" }}>
      <span aria-hidden style={{ background: color }} className="inline-block w-6 h-6 border-2 border-black shadow-[2px_2px_0_#000]" />
      {title}
    </h2>
    <div className="hazard h-2 mt-3" />
  </div>
);

const Card = ({ item, idx }) => (
  <a
    href={item.url}
    target="_blank"
    rel="noreferrer noopener"
    data-testid={`media-card-${idx}`}
    className="block bg-white border-4 border-black shadow-[8px_8px_0_#000] p-5 sm:p-6 hover:translate-x-[3px] hover:translate-y-[3px] hover:shadow-[4px_4px_0_#000] transition-all"
  >
    <div className="flex flex-wrap items-center gap-3 mb-2">
      <TypePill type={item.type} />
      <span className="font-pixel text-base text-black/60">{item.outlet}</span>
    </div>
    <div className="font-display tracking-wider text-2xl sm:text-3xl text-black leading-tight">
      {item.title}
    </div>
    <p className="font-body text-base sm:text-lg mt-2 text-black/80">{item.desc}</p>
    <span className="inline-block mt-3 font-pixel text-lg text-[#B85450] underline">
      open the story →
    </span>
  </a>
);

const Media = () => {
  return (
    <div>
      {/* Hero */}
      <section className="bg-[#0A0A0A] text-white border-b-4 border-black relative overflow-hidden">
        <div className="absolute top-8 left-8 hidden md:block"><StickerStar size={70} rotate={-12} className="float-slow" /></div>
        <div className="absolute bottom-8 right-8 hidden md:block"><StickerBolt size={80} rotate={10} className="float-med" /></div>
        <div className="absolute top-1/2 right-[10%] hidden lg:block"><StickerSun size={70} rotate={14} className="float-slow" /></div>

        <div className="max-w-7xl mx-auto py-20 px-6">
          <div className="font-pixel uppercase tracking-widest text-lg text-white/70">▒▒ press · tv · radio ▒▒</div>
          <h1 className="font-display tracking-wider text-6xl sm:text-7xl lg:text-8xl mt-3 text-[#F4D58D]">MEDIA</h1>
          <p className="font-body text-xl mt-5 max-w-3xl text-white/85">
            The run showed up in the news while I was running it, and a lot of you found out about me from those
            stories. Here's the rolling archive, biggest features at the top.
          </p>
        </div>
      </section>

      {/* Body */}
      <section className="py-16 px-6 relative overflow-hidden">
        <div className="absolute top-10 right-10 hidden md:block"><StickerSurf size={100} rotate={-10} className="float-slow" /></div>
        <div className="absolute bottom-10 left-10 hidden md:block"><StickerWave size={110} rotate={12} className="float-med" /></div>

        <div className="max-w-6xl mx-auto">

          {/* TOP FEATURES */}
          <h2 className="font-display tracking-wider text-5xl text-black leading-none"
              style={{ textShadow: "4px 4px 0 rgba(0,0,0,0.18)" }}>
            TOP FEATURES
          </h2>
          <div className="hazard h-3 mt-3 mb-10" />

          <div className="grid lg:grid-cols-2 gap-8" data-testid="media-top">
            {TOP_FEATURES.map((f, i) => (
              <a
                key={f.rank}
                href={f.url}
                target="_blank"
                rel="noreferrer noopener"
                data-testid={`media-top-${f.rank}`}
                className="block bg-white border-4 border-black shadow-[12px_12px_0_#000] p-6 sm:p-8 hover:translate-x-[3px] hover:translate-y-[3px] hover:shadow-[8px_8px_0_#000] transition-all"
              >
                <div className="flex items-center gap-3 mb-3">
                  <span className="font-display tracking-wider text-3xl" style={{ color: f.color }}>#{f.rank}</span>
                  <TypePill type={f.type} />
                  <span className="font-pixel text-base text-black/60 ml-auto">{f.outlet}</span>
                </div>
                <h3 className="font-display tracking-wider text-3xl sm:text-4xl text-black leading-tight">
                  {f.title}
                </h3>
                <p className="font-body text-base sm:text-lg mt-3 text-black/80">{f.desc}</p>
                <div className="mt-5 inline-block font-display tracking-wider text-xl px-5 py-2 bg-[#F87171] text-white border-4 border-black shadow-[4px_4px_0_#000]">
                  Watch / read →
                </div>
              </a>
            ))}
          </div>

          {/* NATIONAL & MAJOR BROADCAST */}
          <SectionHeader title="NATIONAL & MAJOR BROADCAST" color="#F4A261" />
          <ul className="space-y-5" data-testid="media-national">
            {NATIONAL.map((item, i) => (
              <li key={i}><Card item={item} idx={`nat-${i}`} /></li>
            ))}
          </ul>

          {/* REGIONAL CTV */}
          <SectionHeader title="REGIONAL CTV NETWORK" color="#5BA8C7" />
          <ul className="space-y-5" data-testid="media-regional">
            {REGIONAL_CTV.map((item, i) => (
              <li key={i}><Card item={item} idx={`ctv-${i}`} /></li>
            ))}
          </ul>

          {/* LOCAL PRESS */}
          <SectionHeader title="ONTARIO, PRAIRIES & BC LOCAL PRESS" color="#2A9D8F" />
          <ul className="space-y-5" data-testid="media-local">
            {LOCAL_PRESS.map((item, i) => (
              <li key={i}><Card item={item} idx={`loc-${i}`} /></li>
            ))}
          </ul>

          {/* BOOK TOUR */}
          <SectionHeader title="BOOK TOUR PRESS" color="#B57FA0" />
          <ul className="space-y-5" data-testid="media-book">
            {BOOK_TOUR.map((item, i) => (
              <li key={i}><Card item={item} idx={`book-${i}`} /></li>
            ))}
          </ul>

          <p className="font-pixel text-base text-black/60 text-center mt-14">
            Have an article or video I missed? <a href="mailto:CrossCanadaJax97@gmail.com?subject=Press%20Mention" className="retro-link">Send it over</a> and I'll add it to the wall.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Media;
